import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import StyledLink from './StyledLink'
import TimelineEventTitle from './TImelineEventTitle'
import TimelineEventBody from './TimelineEventBody'
import TimelineEventCard from './TimelineEventCard'





const Link = styled(StyledLink)({
  fontWeight: 600
})

const TimelineEventJoinedParabol = (props) => {
  const {timelineEvent: timelineEventRef} = props
  const timelineEvent = useFragment(
    graphql`
      fragment TimelineEventJoinedParabol_timelineEvent on TimelineEventJoinedParabol {
        ...TimelineEventCard_timelineEvent
        id
      }
    `,
    timelineEventRef
  )
  return (
    React.createElement(TimelineEventCard, {
      iconName: "account_circle",
      timelineEvent: timelineEvent,
      title: React.createElement(TimelineEventTitle, null, "You joined Parabol"  ),}

      , React.createElement(TimelineEventBody, null
        , 'Get started by updating your name and avatar in your '
        , React.createElement(Link, { to: "/me/profile",}, "user profile" )
      )
    )
  )
}

export default TimelineEventJoinedParabol
